var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98931 21.7893C4.18536 22.2839 4.22901 22.8258 4.11464 23.3453L2.69464 27.732C2.64889 27.9545 2.66072 28.1849 2.72901 28.4015C2.7973 28.6181 2.91979 28.8137 3.08486 28.9697C3.24994 29.1257 3.45212 29.2369 3.67224 29.2929C3.89236 29.3488 4.12312 29.3476 4.34264 29.2893L8.89331 27.9587C9.3836 27.8614 9.89135 27.9039 10.3586 28.0813C13.2058 29.411 16.4311 29.6923 19.4655 28.8756C22.4999 28.059 25.1483 26.1969 26.9436 23.6178C28.7388 21.0388 29.5655 17.9085 29.2777 14.7794C28.9899 11.6502 27.6062 8.72329 25.3707 6.51492C23.1352 4.30656 20.1916 2.95871 17.0592 2.70919C13.9267 2.45967 10.8068 3.3245 8.2499 5.15111C5.69297 6.97772 3.86335 9.64872 3.08383 12.6928C2.30432 15.737 2.625 18.9586 3.98931 21.7893Z",
    stroke: "black",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessage);
export default __webpack_public_path__ + "static/media/IconMessage.7fcc8627aa41f7ed21601003b0849b0e.svg";
export { ForwardRef as ReactComponent };